
export const MobileControls = {
    interface: null,

    init(onMove) {
        if (this.interface) return;

        this.interface = document.createElement('div');
        this.interface.id = 'mobile-ui';
        Object.assign(this.interface.style, {
            position: 'fixed',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            gap: '20px',
            zIndex: '1000',
            pointerEvents: 'none'
        });

        // Стили кнопок
        const btnStyle = {
            width: '60px',
            height: '60px',
            backgroundColor: 'rgba(0,0,0,0.5)',
            border: '2px solid white',
            borderRadius: '50%',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '24px',
            pointerEvents: 'all',
            userSelect: 'none',
            webkitUserSelect: 'none'
        };

        const createBtn = (icon, action) => {
            const btn = document.createElement('div');
            Object.assign(btn.style, btnStyle);
            btn.innerHTML = icon;
            btn.addEventListener('touchstart', (e) => {
                e.preventDefault();
                action();
            });
            return btn;
        };

        
        const moveFwd = createBtn('↑', () => onMove());

        this.interface.append(moveFwd);
        document.body.appendChild(this.interface);
    },

    show() { if (this.interface) this.interface.style.display = 'flex'; },
    hide() { if (this.interface) this.interface.style.display = 'none'; },

    
    isTouchDevice() {
        return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0));
    }
};